export default "/build/images/avolta-connect-logo.783a06ef.png";